import React, { useState, useEffect } from "react";

import { getLandingPageActiva, getConfiguracion, getTema, getPayloadMedia } from "../services/payloadService";

// Importar componentes
import Navbar from "../component/Navbar";
import HeroSection from "../component/sections/HeroSection";
import ServiciosSection from "../component/sections/ServiciosSection";
import AboutSection from "../component/sections/AboutSection";
import OtrosServiciosSection from "../component/sections/OtrosServiciosSection";
import PricingSection from "../component/sections/PricingSection";
import TeamSection from "../component/sections/TeamSection";
import EstadisticasSection from "../component/sections/EstadisticasSection";
import CTASection from "../component/sections/CTASection";
import BlogSection from "../component/sections/BlogSection";
import benefitSection from "../component/sections/benefitSection";
import ContactoSection from "../component/sections/ContactoSection";
import Footer from "../component/Footer";

export default function Index() {
    const [landingPage, setLandingPage] = useState(null);
    const [configuracion, setConfiguracion] = useState(null);
    const [tema, setTema] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isMenuOpen, setMenu] = useState(true);

    // Mapa de componentes de secciones (Payload blockType)
    const SECTION_COMPONENTS = {
        'hero': HeroSection,
        'servicios': ServiciosSection,
        'about': AboutSection,
        'otrosServicios': OtrosServiciosSection,
        'pricing': PricingSection,
        'team': TeamSection,
        'estadisticas': EstadisticasSection,
        'cta': CTASection,
        'blog': BlogSection,
        'beneficios': benefitSection,
        'contacto': ContactoSection,
    };

    const windowScroll = () => {
        const navbar = document.getElementById('navbar');
        if (!navbar) return; // Protección si el navbar no existe
        
        if (document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50) {
            navbar.classList.add('nav-sticky');
        } else {
            navbar.classList.remove('nav-sticky');
        }
    };

    const toggleMenu = () => {
        setMenu(!isMenuOpen);
    };

    useEffect(() => {
        window.addEventListener('scroll', windowScroll);

        return () => {
            window.removeEventListener('scroll', windowScroll);
        };
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Obtener la landing page activa (sin slug)
                const [landing, config, themeData] = await Promise.all([
                    getLandingPageActiva(),
                    getConfiguracion(),
                    getTema()
                ]);

                setLandingPage(landing);
                setConfiguracion(config);
                setTema(themeData);
            } catch (error) {
                console.error('Error al cargar landing page:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // Inyectar variables CSS dinámicas desde el tema
    useEffect(() => {
        // Solo los 4 colores principales que realmente se usan y son visibles
        const colors = {
            '--color-primary': tema?.colorPrimario || '#8cb369',           // Botones, iconos principales
            '--color-primary-hover': tema?.colorPrimarioHover || '#7faa58', // Hover de botones
            '--color-success': tema?.colorSuccess || '#52CC99',              // Checkmarks en pricing
            '--color-danger': tema?.colorDanger || '#d9534f',                 // X marks en pricing
            '--color-titulo': tema?.colorTitulo || '#161c2d',                // Color para títulos
            '--color-body': tema?.colorBody || '#495057'                     // Color del texto principal
        };

        // Aplicar directamente al :root (máxima prioridad)
        Object.entries(colors).forEach(([key, value]) => {
            document.documentElement.style.setProperty(key, value);
        });

        // Cleanup al desmontar
        return () => {
            Object.keys(colors).forEach(key => {
                document.documentElement.style.removeProperty(key);
            });
        };
    }, [tema]);

    if (loading) {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center vh-100">
                  <img src={'/logo-recio.svg'} alt="logo" style={{width: '100px', height: '100px'}} />
                <div className="spinner-border text-primary" role="status">
                </div>
            </div>
        );
    }

    if (!landingPage) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="text-center">
                    <h2>No hay landing page activa</h2>
                    <p className="text-muted">Por favor crea y activa una landing page en Payload CMS</p>
                </div>
            </div>
        );
    }

    return (
        <>
            <div>
                {/* Navbar */}
                <Navbar
                    landingPage={landingPage}
                    configuracion={configuracion}
                    isMenuOpen={isMenuOpen}
                    toggleMenu={toggleMenu}
                />

                {/* Renderizar secciones dinámicamente */}
                {landingPage?.secciones?.map((seccion, index) => {
                    const SectionComponent = SECTION_COMPONENTS[seccion.blockType];

                    if (!SectionComponent) {
                        console.warn(`Componente no encontrado para blockType: ${seccion.blockType}`, seccion);
                        return null;
                    }

                    // Pasar configuración a secciones que la necesitan (contacto)
                    const props = { data: seccion, configuracion };

                    return <SectionComponent key={seccion.id || index} {...props} />;
                })}

                {/* Footer */}
                <Footer configuracion={configuracion} />
            </div>
        </>
    );
}
